import "./contactmap.scss";

import "./contactinfo.scss";
const Contactmap = () => {
  return (
    <div>
      <div className="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3913.997706746363!2d79.1083312!3d10.7784427!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baab8ada6c5170f%3A0xb76236b229ab5934!2s186%2C%20Thendral%20Nagar%2C%20Sundram%20Nagar%2C%20Thanjavur%2C%20Tamil%20Nadu%20613004!5e0!3m2!1sen!2sin!4v1760000000000"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
        ></iframe>


      </div>
    </div>
  );
};
export default Contactmap;
